import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { FooterPrintLayoutComponent, HeaderPrintLayoutComponent, TranslationModule } from '@hdms/shared/feature';
import { SearchSuggestionService } from '@hdms/shared/page-frame/data-access';
import {
  HeaderContentSliderModule,
  HeaderMetaNavModule,
  HeaderUILogoModule,
  HeaderUIUserModule,
  LinksColumnModule
} from '@hdms/shared/page-frame/ui';
import {
  ButtonModule,
  FlyoutModule,
  MobileModalWindowModule,
  ModalModule,
  NavButtonModule,
  SvgIconModule
} from '@hdms/shared/ui-core';
import {
  AnalyticsModule,
  AssetPathModule,
  FeatureToggleModule,
  LetModule,
  PlatformModule,
  RouterLinkModule,
  StorageModule
} from '@hdms/shared/util-core';

import { GlobalBannerComponent } from './components/global-banner/global-banner.component';
import { HeaderBurgerMenuModule } from './components/header-burger-menu/header-burger-menu.module';
import { HeaderCartComponent } from './components/header-cart/header-cart.component';
import { ContactModalModule } from './components/header-contact/contact-modal/contact-modal.module';
import { HeaderLoggedModeComponent } from './components/header-logged-mode/header-logged-mode.component';
import { ManageMyToolsComponent } from './components/header-manage-my-tools/manage-my-tools.component';
import { HeaderMegaMenuModule } from './components/header-mega-menu/header-mega-menu.module';
import { HeaderMenuSeoOnlyLinksModule } from './components/header-menu-seo-only-links/header-menu-seo-only-links.module';
import { ContactPopoverContentModule } from './components/header-popover/contact-popover-content/contact-popover-content.module';
import { HeaderUIMetaPopoverModule } from './components/header-popover/header-meta-popover/header-meta-popover.module';
import { HeaderSearchPopoverModule } from './components/header-popover/header-search-popover/header-search-popover.module';
import { HeaderUserPopoverModule } from './components/header-popover/header-user-popover/header-user-popover.module';
import { HeaderUserPopoverContentModule } from './components/header-popover/user-popover-content/user-popover-content.module';
import { HeaderRegistrationButtonComponent } from './components/header-registration/header-registration-button.component';
import { HeaderSearchMobileModule } from './components/header-search/search-mobile/search-mobile.module';
import { SelectCurrencyModule } from './components/header-select/select-currency/select-currency.module';
import { SelectLanguageModule } from './components/header-select/select-language/select-language.module';
import { HeaderUserWrapperModule } from './components/header-user-wrapper/header-user-wrapper.module';
import { MarketingBannersComponent } from './components/marketing-banners/marketing-banners.component';
import { PageFooterComponent } from './components/page-footer/page-footer.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { AccountLinksService, MenuStateService, SearchSuggestionKeyboardControlService } from './services';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    SvgIconModule,
    TranslationModule,
    AssetPathModule,
    LinksColumnModule,
    HeaderBurgerMenuModule,
    HeaderMegaMenuModule,
    HeaderMenuSeoOnlyLinksModule,
    HeaderMetaNavModule,
    HeaderUIMetaPopoverModule,
    HeaderUIUserModule,
    LetModule,
    FlyoutModule,
    NgbPopoverModule,
    MobileModalWindowModule,
    ModalModule,
    NavButtonModule,
    HeaderUILogoModule,
    HeaderUserPopoverModule,
    HeaderUserPopoverContentModule,
    HeaderUserWrapperModule,
    HeaderRegistrationButtonComponent,
    HeaderSearchMobileModule,
    HeaderSearchPopoverModule,
    HeaderContentSliderModule,
    SelectCurrencyModule,
    SelectLanguageModule,
    ContactPopoverContentModule,
    ContactModalModule,
    FeatureToggleModule,
    RouterLinkModule,
    HeaderCartComponent,
    MarketingBannersComponent,
    AnalyticsModule,
    PlatformModule,
    StorageModule.forChild('pf', true, true),
    HeaderPrintLayoutComponent,
    FooterPrintLayoutComponent,
    ManageMyToolsComponent
  ],
  declarations: [PageHeaderComponent, HeaderLoggedModeComponent, PageFooterComponent, GlobalBannerComponent],
  exports: [PageHeaderComponent, PageFooterComponent, GlobalBannerComponent],
  providers: [MenuStateService, SearchSuggestionService, AccountLinksService, SearchSuggestionKeyboardControlService]
})
export class SharedPageFrameFeatureModule {}
